import Vue from "vue";
import moment from "moment";

Vue.filter("currency", (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
});

Vue.filter("fixedFloat", (value, decimals = 2) => {
  if (isNaN(value)) return null;
  return Number(parseFloat(value).toFixed(decimals));
});

Vue.filter("percentage", (value) => {
  if (isNaN(value)) return null;
  return String((value * 100).toFixed(2)) + "%";
});

Vue.filter("capitalize", (value) => {
  if (!value) return "";
  return value.replace(/\b(\w)(\w*)/g, (match, firstLetter, restOfWord) => {
    return firstLetter.toUpperCase() + restOfWord;
  });
});

Vue.filter("addComma", (value) => {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? "";
});

Vue.filter("phoneNumber", (value) => {
  var cleaned = ("" + value).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return "";
});

Vue.filter("dateFormat", (value) => {
  if (!value) return "";
  return moment(value).format("MM/DD/YYYY");
});

Vue.filter("shortDateFormat", (value) => {
  if (!value) return "";
  return moment(value).format("M/D/YY");
});

Vue.filter("firstLastInitial", (value) => {
  if (!value) return "";
  const words = value.trim().split(/\s+/);
  if (words.length < 2) {
    return words[0].replace(
      /\b(\w)(\w*)/g,
      (match, firstLetter, restOfWord) => {
        return firstLetter.toUpperCase() + restOfWord;
      }
    );
  }
  return (
    words[0].charAt(0).toUpperCase() +
    words[0].slice(1).toLowerCase() +
    " " +
    words[1].charAt(0).toUpperCase() +
    "."
  );
});

Vue.filter("obfuscateEmail", (value) => {
  if (!value || typeof value !== "string") return "";

  const email = value.trim();
  const atIndex = email.indexOf("@");

  // If no @ found, return as is or handle gracefully
  if (atIndex === -1) return email;

  const localPart = email.substring(0, atIndex);
  const domainPart = email.substring(atIndex + 1);

  // Obfuscate local part (before @)
  let obfuscatedLocal = "";
  if (localPart.length <= 2) {
    obfuscatedLocal = "*".repeat(localPart.length);
  } else {
    // Show first char, up to 5 asterisks, last char
    const numAsterisks = Math.min(localPart.length - 2, 5);
    obfuscatedLocal =
      localPart.charAt(0) +
      "*".repeat(numAsterisks) +
      localPart.charAt(localPart.length - 1);
  }

  // Obfuscate domain part (after @)
  // Split domain into name and TLD (e.g., "gmail.com" -> "gmail" and ".com")
  const lastDotIndex = domainPart.lastIndexOf(".");
  let domainName = domainPart;
  let tld = "";

  if (lastDotIndex !== -1) {
    domainName = domainPart.substring(0, lastDotIndex);
    tld = domainPart.substring(lastDotIndex);
  }

  let obfuscatedDomain = "";
  if (domainName.length <= 2) {
    obfuscatedDomain = "*".repeat(domainName.length) + tld;
  } else {
    // Show first char, up to 5 asterisks, last char, then TLD
    const numAsterisks = Math.min(domainName.length - 2, 5);
    obfuscatedDomain =
      domainName.charAt(0) +
      "*".repeat(numAsterisks) +
      domainName.charAt(domainName.length - 1) +
      tld;
  }

  return `${obfuscatedLocal}@${obfuscatedDomain}`;
});
